import { useNavigate } from 'react-router-dom';

import { Button } from '../Button/Button';

import styles from './ActionMenu.module.scss';

export function ActionsMenu() {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  };

  const handleSignUp = () => {
    navigate('/signup');
  };
  return (
    <div className={styles.actionsMenu}>
      <Button className={styles.signUpButton} variant="default" onClick={handleSignUp}>
        Зарегистрироваться
      </Button>
      <Button className={styles.signInButton} variant="outlined" onClick={handleLogin}>
        Войти
      </Button>
    </div>
  );
}
